import { Link, Text } from 'platform-components';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import * as lessonSelectors from 'common.components/lesson/selectors';
import { LessonStore } from 'common.components/lesson/typings';

interface HOCProps extends WithRouterPathProps {}

interface OwnProps {
    disabled?: boolean;
    onClick: (studentId: number) => void;
    studentId: number;
    studentName: string;
}

interface StoreProps {
    clessonId: number | null;
    courseId: number | null;
}

interface Props extends HOCProps, OwnProps, StoreProps {}

const StudentLink = ({ disabled, onClick, studentId, studentName }: Props) => {
    const handleClick = useCallback(() => {
        onClick(studentId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [studentId]);

    return (
        <Link disabled={disabled} mix="results__student-link" onClick={handleClick} theme={Link.THEME.PRIMARY}>
            <Text ellipsis>{studentName}</Text>
        </Link>
    );
};

const mapStateToProps = <T extends LessonStore>(storeState: T): StoreProps => {
    return {
        clessonId: lessonSelectors.getCLessonId(storeState),
        courseId: lessonSelectors.getLessonCourseId(storeState),
    };
};

export default withRouterPath(connect(mapStateToProps)(StudentLink));
